var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"text-center",attrs:{"id":_vm.qrCodeId}}),(_vm.showDownloadButton)?_c('v-btn',{staticClass:"mb-2",attrs:{"text":"","outlined":"","min-width":"200"},on:{"click":_vm.downloadQRCode}},[_vm._v("Download QR Code")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }